import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface IMeetingRatingsPayloadState extends ISagaCb {}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const meetingRatingsSlice = createSlice({
    name: 'meeting-statistics/meetign-ratings',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IMeetingRatingsPayloadState>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const meetingRatingsActions = meetingRatingsSlice.actions
export default meetingRatingsSlice.reducer
